import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import { regexOrganisationNumber } from '~/helpers/regex';
import TextFieldWithControl from '~/App/shared/components/Fields/TextFieldWithControl';
import { TextFieldProps } from '../types';

const OrganisationNumberField = <FormState extends FieldValues>({
  control,
  t,
  name,
  rules,
  country = 'se',
  label,
  ...props
}: TextFieldProps<FormState> & { country?: string }) => {
  const validationRules = {
    required: {
      value: true,
      message: t(`Organisation number can't be blank`)
    },
    pattern:
      country === 'se'
        ? {
            value: regexOrganisationNumber,
            message: t('Organisation number is invalid')
          }
        : undefined,
    ...rules
  };

  const fieldName = name ?? ('organisationNumber' as Path<FormState>);

  return (
    <TextFieldWithControl
      {...props}
      control={control}
      name={fieldName}
      label={label ?? t('Organisation number')}
      rules={validationRules}
      required
    />
  );
};

export default OrganisationNumberField;
